import { render, staticRenderFns } from "./articulo_quickview.vue?vue&type=template&id=02e7c243&"
import script from "./articulo_quickview.vue?vue&type=script&lang=js&"
export * from "./articulo_quickview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports